module.exports = __webpack_public_path__ + "media/images/slide-16-2a1ecad76e8b489223880209410856d6.jpg";